import React, { useState, useEffect } from 'react';
import { makeStyles, Box, TextField, DialogTitle, DialogContent, Popover } from '@material-ui/core';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import Typography from '@material-ui/core/Typography';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import RefreshIcon from '@material-ui/icons/Refresh';
import { useHistory } from 'react-router-dom';
import { PasswordGenerator as pg } from '../common/PasswordGenerator';
import LoadingSpinner from './../LoadingSpinner';
import { createReport } from './ReportsAPI';

const useStyles = makeStyles({
  dialogPaper: {
    maxWidth: '496px',
    maxHeight: '542px',
  },
  dialogPadding: {
    paddingLeft: '32px',
    paddingRight: '32px',
  },
  dataExportImg: {
    maxHeight: '280px',
  },
  popoverDiv: {
    // display: 'flex',
  },
  popoverTypo: {
    color: '#546E7A',
    fontSize: '12px',
  },
});

const AddNewDialog = ({ openDialogFlag, handleClose, ...rest }) => {
  const classes = useStyles();
  const [name, setName] = useState('');
  const [password, setPassword] = useState('');
  const [radioBtnVal, setRadioBtnVal] = React.useState('default');
  const [passwordSuggestion, setPasswordSuggestion] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  useEffect(() => {
    setPasswordSuggestion(pg(10));
  }, []);

  let history = useHistory();
  const handleChange = event => {
    setRadioBtnVal(event.target.value);
  };

  const [anchorEl, setAnchorEl] = React.useState(null);

  const handleClosePop = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? 'simple-popover' : undefined;

  const handleCreateNew = () => {
    setIsLoading(true);
    createReport({
      name: name,
      password: password,
      default_template: radioBtnVal === 'default' ? true : false,
      timestamp: new Date(),
    })
      .then(function (response) {
        setIsLoading(false);
        history.push(`/reports/edit/${response.data.report_id}`);
      })
      .catch(function (response) {setIsLoading(false);});
  };

  const handleRefresh = () => {
    let newPassword = pg(10);
    setPasswordSuggestion(newPassword);
  };
  const handleSaveAutoPass = e => {
    setPassword(passwordSuggestion);
    handleClosePop();
  };

  return (
    <Dialog open={openDialogFlag} onClose={handleClose} classes={{ paper: classes.dialogPaper }}>
      <DialogTitle id="add-new-report-dialog" style={{ paddingBottom: '0px' }}>
        Create New Report
      </DialogTitle>
      <DialogContent>
        <TextField
          fullWidth
          autoFocus
          label="Report Name"
          margin="normal"
          name="report_name"
          type="text"
          defaultValue=""
          variant="outlined"
          onChange={e => setName(e.target.value)}
        />
        <TextField
          fullWidth
          label="Password"
          margin="normal"
          name="report_password"
          type="text"
          value={password}
          variant="outlined"
          autoComplete="off"
          onChange={e => setPassword(e.target.value)}
          onPointerDown={e => setAnchorEl(e.currentTarget)}
          aria-describedby={id}
        />
        <Popover
          id={id}
          open={open}
          anchorEl={anchorEl}
          onClose={handleClosePop}
          onKeyDown={handleClosePop}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'center',
          }}
          transformOrigin={{
            vertical: 'top',
            horizontal: 'center',
          }}
          disableAutoFocus
          disableEnforceFocus
          PaperProps={{
            style: { width: '415px', padding: '15px', border: '1px solid #C4C4C4' },
          }}
        >
          <Typography className={classes.popoverTypo}>involve.ai generated a strong password</Typography>
          <div className={classes.popoverDiv}>
            <Button
              style={{ float: 'left', textTransform: 'none' }}
              onClick={handleSaveAutoPass}
              className={classes.button}
            >
              {passwordSuggestion}
            </Button>
            <Button
              style={{ float: 'right' }}
              color="primary"
              onClick={handleRefresh}
              className={classes.button}
              startIcon={<RefreshIcon />}
            >
              Refresh
            </Button>
          </div>
        </Popover>

        <FormControl component="fieldset">
          <RadioGroup
            aria-label="report-template"
            name="report-template-type"
            value={radioBtnVal}
            onChange={handleChange}
          >
            <FormControlLabel value="default" control={<Radio color="primary" />} label="Use default report template" />
            <FormControlLabel value="new" control={<Radio color="primary" />} label="Create new" />
          </RadioGroup>
        </FormControl>
      </DialogContent>

      <DialogActions style={{ justifyContent: 'flex-start', padding: '8px 24px 16px 24px' }}>
        <Button onClick={handleClose} variant="contained">
          Cancel
        </Button>
        <Box flexGrow="1" />
        { isLoading ? <LoadingSpinner /> :
        <Button
          onClick={handleCreateNew}
          color="primary"
          type="submit"
          variant="contained"
          disabled={name === '' || password === ''}
        >
          CREATE
        </Button>}
      </DialogActions>
    </Dialog>
  );
};
export default AddNewDialog;
